import FeedbackIcon from "@mui/icons-material/Feedback";
import { Fab, Tooltip } from "@mui/material";
import type { FC } from "react";
import { Link } from "react-router-dom";

export interface FeedbackButtonProps {
  targetUrl: string;
}

export const FeedbackButton: FC<FeedbackButtonProps> = ({ targetUrl }) => {
  return (
    <Link to={targetUrl} target="_blank">
      <Tooltip title={"Support us with your feedback"} arrow>
        <Fab
          size={"medium"}
          color="primary"
          aria-label={"Provide Feedback"}
          sx={{ position: "fixed", bottom: 12, right: 8, zIndex: 2000 }}
        >
          <FeedbackIcon />
        </Fab>
      </Tooltip>
    </Link>
  );
};
